<div class="connection-edit">
  <header class="connection-edit__header">
    <button type="button" class="connection-edit__back-tab" (click)="backToConnections()">
      <i class="ms-Icon ms-Icon--Back" aria-hidden="true"></i>
      <span>Connections</span>
    </button>

    <div class="connection-edit__title">
      <h1>{{ (connectorStub?.displayName) || connectorName }}</h1>
      <p>{{ envName }} / {{ connectorName }}</p>
    </div>

    <nav class="connection-edit__tabs" aria-label="Connector edit tabs">
      <button type="button" class="active" disabled>
        <i class="ms-Icon ms-Icon--PlugDisconnected" aria-hidden="true"></i>
        <span>Connector</span>
      </button>
    </nav>
  </header>

  @if (error) {
    <div class="connection-edit__error">{{ error }}</div>
  }

  @if (connectorStub && !loading) {
    <section class="connection-edit__panel">
      <app-flow-detail [editorType]="'Connector'" [connection]="connectorStub"></app-flow-detail>
    </section>
  } @else {
    @if (loading) {
      <div class="connection-edit__loading">Loading…</div>
    }
  }

</div>
